import { cn } from '@/lib/utils';
import type { BaseControlProps } from '@/pages/WorkflowsCatalog/components/run/controls/types';
import type { FieldValues } from 'react-hook-form';

const StringFormControl = <T extends FieldValues>({ field }: BaseControlProps<T>) => {
  const value = (field.value as string) ?? '';
  const lineCount = (value.match(/\n/g) || []).length + 1;
  const isLong = value.length > 100 || lineCount > 1;

  return (
    <textarea
      {...field}
      value={value}
      onChange={(e) => field.onChange(e.target.value)}
      rows={isLong ? Math.min(lineCount + 1, 8) : 1}
      className={cn(
        'flex w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50',
        'resize-none field-sizing-content',
        isLong ? 'min-h-[80px] max-h-[200px] overflow-y-auto' : 'min-h-[38px]'
      )}
    />
  );
};

export default StringFormControl;
